// MobilizeStartConfirmationView.js
import React from 'react';
import './MobilizeStartConfirmationView.css';
import { TbAlertCircle } from 'react-icons/tb';
import ActionButton from '../../../../../Components/custom_components/CustomButtons/ActionButton/ActionButton';

const MobilizeStartConfirmationView = ({ scheduleName, onConfirm, onCancel, isButtonDisabled }) => {

    return (
        <div className="mobilize-confirmation-container">
            <div className="mobilize-confirmation-title">
                <TbAlertCircle style={{ fontSize: 22, color: '#f57c00' }} />
                Do you want to mobilize the schedule <strong>{scheduleName}</strong>?
            </div>

            <div className="form-bottom-action-buttons-container">
                <ActionButton onClick={onCancel} label="Cancel" btnType="outlined" />
                <ActionButton btnDisable={isButtonDisabled} onClick={onConfirm} label="Mobilize" btnType="primary" />
            </div>
        </div>
    );
};

export default MobilizeStartConfirmationView;
